<template>
  <div v-if="permissoes.editar_configuracoes || permissoes.ler_configuracoes">
    <!-- Breadcrumb e Cabeçalho -->
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Configurações dos Fabricantes</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <!-- Título -->
    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h1>Configurações dos Fabricantes</h1>
      </el-col>
    </el-row>
    <!-- Botão Novo -->
    <el-row type="flex" style="text-align: left; margin-bottom: 10px;">
      <el-col :span="24">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          v-if="permissoes.editar_configuracoes"
          @click="formConfiguracoesFabricanteOpen()"
        >Novo</el-button>
      </el-col>
    </el-row>
    <!-- Tabela -->
    <el-row type="flex" justify="start" aling="left">
      <el-col :span="24">
        <el-table
          :data="configuracoesFabricantes"
          style="width: 100%"
          v-loading="loading"
          element-loading-text="Loading..."
        >
          <el-table-column prop="fabricante_id" label="ID" width="60" sortable></el-table-column>
          <el-table-column prop="razao_social" label="Nome" width="300" sortable></el-table-column>
          <el-table-column prop="lucro" label="Lucro" width="60" align="right"></el-table-column>
          <el-table-column prop="desconto_representante" label="Desconto Representante" width="185" align="right"></el-table-column>
          <el-table-column prop="desconto_administrador" label="Desconto Administrador" width="185" align="right"></el-table-column>
          <el-table-column prop="despesas_administrativas" label="Despesas Administrativas" width="200" align="right"></el-table-column>
          <el-table-column prop="custo_indireto" label="Custo Indireto" width="120" align="right"></el-table-column>
          <el-table-column prop="gastos_gerais_fabricacao" label="Gastos Gerais de Fabricação" width="215" align="right"></el-table-column>
          <el-table-column prop="comissao_gerente" label="Comissão Gerente" width="145" align="right"></el-table-column>
          <el-table-column prop="comissao_interna" label="Comissão Interna" width="145" align="right"></el-table-column>
          <el-table-column prop="comissao_externa" label="Comissão Externa" width="145" align="right"></el-table-column>
          <el-table-column prop="indicador_externo" label="Indicador Externo" width="145" align="right"></el-table-column>
          <el-table-column prop="fabricante_contato_nome" label="Fabricante Contato Nome" width="220"></el-table-column>
          <el-table-column prop="empresa_representante_nome" label="Empresa Representante Nome" width="230"></el-table-column>
          <el-table-column prop="eh_fabricante" label="É Fabricante?" width="115">
            <template slot-scope="scope">
              {{ scope.row.eh_fabricante === 'S' ? 'Sim' : scope.row.eh_fabricante === 'N' ? 'Não' : scope.row.eh_fabricante }}
            </template>
          </el-table-column>
          <el-table-column label="Ação" width="200">
            <template slot-scope="scope">
              <el-button size="mini" icon="el-icon-edit" type="primary" @click="formConfiguracoesFabricanteOpen(scope.row)">Editar</el-button>
              <el-button
                v-if="permissoes.excluir_contatos"
                size="mini"
                type="danger"
                icon="el-icon-delete"
                @click="deleteConfiguracoesFabricante(scope.row)"
              >Excluir</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  
    <!-- Formulário -->
    <el-dialog
      :title="formDataConfiguracoesFabricante.id ? 'Editar Configuração' : 'Nova Configuração'"
      :visible.sync="formConfiguracoesFabricanteVisible"
      :show-close="false"
    >
      <el-form 
        :model="formDataConfiguracoesFabricante" 
        :rules="rules" 
        ref="formConfiguracoesFabricante" 
        label-position="right"
        label-width="250px"
      >
<!--       
        <el-form-item label="ID Fabricante" prop="fabricante_id">
          <el-input v-model="formDataConfiguracoesFabricante.fabricante_id" />
        </el-form-item>
 -->
        <el-form-item label="Fabricante" style="text-align: left">
          <el-select
            v-model="formDataConfiguracoesFabricante.fabricante_id"
            filterable
            placeholder="Informe o Fabricante"
            :disabled="formDataConfiguracoesFabricante.fabricante_id === 0"
            style="width: 100%;"
          >
            <el-option
              v-for="item in listaFabricantes"
              :key="item.CODIGO"
              :label="item.RAZAO_SOCIAL"
              :value="parseInt(item.CODIGO)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Lucro" prop="lucro">
          <el-input v-model="formDataConfiguracoesFabricante.lucro" />
        </el-form-item>
        <el-form-item label="Desconto Representante" prop="desconto_representante">
          <el-input v-model="formDataConfiguracoesFabricante.desconto_representante" />
        </el-form-item>
        <el-form-item label="Desconto Administrador" prop="desconto_administrador">
          <el-input v-model="formDataConfiguracoesFabricante.desconto_administrador" />
        </el-form-item>
        <el-form-item label="Despesas Administrativas" prop="despesas_administrativas">
          <el-input v-model="formDataConfiguracoesFabricante.despesas_administrativas" />
        </el-form-item>
        <el-form-item label="Custo Indireto" prop="custo_indireto">
          <el-input v-model="formDataConfiguracoesFabricante.custo_indireto" />
        </el-form-item>
        <el-form-item label="Gastos Gerais de Fabricação" prop="gastos_gerais_fabricacao">
          <el-input v-model="formDataConfiguracoesFabricante.gastos_gerais_fabricacao" />
        </el-form-item>
        <el-form-item label="Empresa Representante Nome" prop="empresa_representante_nome">
          <el-input v-model="formDataConfiguracoesFabricante.empresa_representante_nome" />
        </el-form-item>
        <el-form-item label="Empresa Representante Email" prop="empresa_representante_email">
          <el-input v-model="formDataConfiguracoesFabricante.empresa_representante_email" />
        </el-form-item>
        <el-form-item label="Empresa Representante Telefone" prop="empresa_representante_telefone">
          <el-input v-model="formDataConfiguracoesFabricante.empresa_representante_telefone" />
        </el-form-item>
        <el-form-item label="Comissão Gerente" prop="comissao_gerente">
          <el-input v-model="formDataConfiguracoesFabricante.comissao_gerente" />
        </el-form-item>
        <el-form-item label="Comissão Interna" prop="comissao_interna">
          <el-input v-model="formDataConfiguracoesFabricante.comissao_interna" />
        </el-form-item>
        <el-form-item label="Comissão Externa" prop="comissao_externa"> 
          <el-input v-model="formDataConfiguracoesFabricante.comissao_externa" />
        </el-form-item>
        <el-form-item label="Indicador Externo" prop="indicador_externo">
          <el-input v-model="formDataConfiguracoesFabricante.indicador_externo" />
        </el-form-item> 
        <el-form-item label="Fabricante Contato Nome" prop="fabricante_contato_nome">
          <el-input v-model="formDataConfiguracoesFabricante.fabricante_contato_nome" />
        </el-form-item>
        <el-form-item label="Fabricante Contato Cargo" prop="fabricante_contato_cargo">
          <el-input v-model="formDataConfiguracoesFabricante.fabricante_contato_cargo" />
        </el-form-item>
        <el-form-item label="Fabricante Contato Email" prop="fabricante_contato_email">
          <el-input v-model="formDataConfiguracoesFabricante.fabricante_contato_email" />
        </el-form-item>
        <el-form-item label="Fabricante Contato Telefone" prop="fabricante_contato_telefone">
          <el-input v-model="formDataConfiguracoesFabricante.fabricante_contato_telefone" />
        </el-form-item>
        <el-form-item label="Fabricante no RS" prop="fabricante_rs">
          <el-select 
            v-model="formDataConfiguracoesFabricante.fabricante_rs" 
            placeholder="Selecione"
            :disabled="formDataConfiguracoesFabricante.fabricante_id === 0"
            style="width: 100%"
          >
            <el-option label="Sim" value="S" />
            <el-option label="Não" value="N" />
          </el-select>
        </el-form-item>
        <el-form-item label="Faturamento" prop="faturamento">
          <el-input v-model="formDataConfiguracoesFabricante.faturamento" />
        </el-form-item>
        <el-form-item label="Tipo" prop="frete_tipo">
          <el-select 
            v-model="formDataConfiguracoesFabricante.frete_tipo" 
            placeholder="Selecione"
            style="width: 100%"
          >
            <el-option label="CIF" value="CIF" />
            <el-option label="FOB" value="FOB" />
          </el-select>
        </el-form-item>
        <el-form-item label="Frete Empresa" prop="frete_empresa">
          <el-input v-model="formDataConfiguracoesFabricante.frete_empresa" />
        </el-form-item>
        <el-form-item label="Frete Local Cidade" prop="frete_local_cidade">
          <el-input v-model="formDataConfiguracoesFabricante.frete_local_cidade" />
        </el-form-item>
        <el-form-item label="Frete Local UF" prop="frete_local_uf">
          <el-select 
            v-model="formDataConfiguracoesFabricante.frete_local_uf" 
            placeholder="Selecione"
            filterable
            style="width: 100%"
          >
            <el-option label="Acre (AC)" value="AC" />
            <el-option label="Alagoas (AL)" value="AL" />
            <el-option label="Amapá (AP)" value="AP" />
            <el-option label="Amazonas (AM)" value="AM" />
            <el-option label="Bahia (BA)" value="BA" />
            <el-option label="Ceará (CE)" value="CE" />
            <el-option label="Distrito Federal (DF)" value="DF" />
            <el-option label="Espírito Santo (ES)" value="ES" />
            <el-option label="Goiás (GO)" value="GO" />
            <el-option label="Maranhão (MA)" value="MA" />
            <el-option label="Mato Grosso (MT)" value="MT" />
            <el-option label="Mato Grosso do Sul (MS)" value="MS" />
            <el-option label="Minas Gerais (MG)" value="MG" />
            <el-option label="Pará (PA)" value="PA" />
            <el-option label="Paraíba (PB)" value="PB" />
            <el-option label="Paraná (PR)" value="PR" />
            <el-option label="Pernambuco (PE)" value="PE" />
            <el-option label="Piauí (PI)" value="PI" />
            <el-option label="Rio de Janeiro (RJ)" value="RJ" />
            <el-option label="Rio Grande do Norte (RN)" value="RN" />
            <el-option label="Rio Grande do Sul (RS)" value="RS" />
            <el-option label="Rondônia (RO)" value="RO" />
            <el-option label="Roraima (RR)" value="RR" />
            <el-option label="Santa Catarina (SC)" value="SC" />
            <el-option label="São Paulo (SP)" value="SP" />
            <el-option label="Sergipe (SE)" value="SE" />
            <el-option label="Tocantins (TO)" value="TO" />
          </el-select>
        </el-form-item>
        <el-form-item label="É Fabricante" prop="eh_fabricante">
          <el-select 
            v-model="formDataConfiguracoesFabricante.eh_fabricante" 
            placeholder="Selecione"
            :disabled="formDataConfiguracoesFabricante.fabricante_id === 0"
            style="width: 100%"
          >
            <el-option label="Sim" value="S" />
            <el-option label="Não" value="N" />
          </el-select>
        </el-form-item>
        <el-form-item label="Fabricante Imagem" prop="fabricante_imagem">
          <el-input v-model="formDataConfiguracoesFabricante.fabricante_imagem" :disabled="formDataConfiguracoesFabricante.fabricante_id === 0"/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="formConfiguracoesFabricanteClose()">Cancelar</el-button>
        <el-button type="primary" @click="submitConfiguracoesFabricante()">Salvar</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>

import axios from "axios";
import FuncoesUteis from "../plugins/FuncoesUteis";

const url = "/api";

export default {

  data() {
    return {
      loading: true,
      formConfiguracoesFabricanteVisible: false,
      permissoes: {},
      listaFabricantes: [],
      configuracoesFabricantes: [],
      formDataConfiguracoesFabricante: {},
      rules: {
        fabricante_id: [
          { required: true, message: "Por Favor, informe o ID do Fabricante", trigger: "blur" },
        ],
        lucro: [
          { required: true, message: "Por Favor, informe o Lucro", trigger: "blur" },
        ],
        desconto_representante: [
          { required: true, message: "Por Favor, informe o Desconto do Representante", trigger: "blur" },
        ],
        desconto_administrador: [
          { required: true, message: "Por Favor, informe o Desconto do Administrador", trigger: "blur" },
        ],
        despesas_administrativas: [
          { required: true, message: "Por Favor, informe as Despesas Administrativas", trigger: "blur" },
        ],
        custo_indireto: [
          { required: true, message: "Por Favor, informe o Custo Indireto", trigger: "blur" },
        ],
        gastos_gerais_fabricacao: [
          { required: true, message: "Por Favor, informe os Gastos Gerais de Fabricação", trigger: "blur" },
        ],
        empresa_representante_nome: [
          { required: true, message: "Por Favor, informe o Nome do Representante da Empresa", trigger: "blur" },
        ],
        empresa_representante_email: [
          { required: true, message: "Por Favor, informe o Email do Representante da Empresa", trigger: "blur" },
          { type: 'email', message: 'Por Favor, informe um email válido', trigger: 'blur' },
        ],
        empresa_representante_telefone: [
          { required: true, message: "Por Favor, informe o Telefone do Representante da Empresa", trigger: "blur" },
        ],
        comissao_gerente: [
          { required: true, message: "Por Favor, informe a Comissão do Gerente", trigger: "blur" },
        ],
        comissao_interna: [
          { required: true, message: "Por Favor, informe a Comissão Interna", trigger: "blur" },
        ],
        comissao_externa: [
          { required: true, message: "Por Favor, informe a Comissão Externa", trigger: "blur" },
        ],
        indicador_externo: [
          { required: true, message: "Por Favor, informe o Indicador Externo", trigger: "blur" },
        ],
        fabricante_contato_nome: [
          { required: true, message: "Por Favor, informe o Nome do Contato do Fabricante", trigger: "blur" },
        ],
        fabricante_contato_cargo: [
          { required: true, message: "Por Favor, informe o Cargo do Contato do Fabricante", trigger: "blur" },
        ],
        fabricante_contato_email: [
          { required: true, message: "Por Favor, informe o Email do Contato do Fabricante", trigger: "blur" },
          { type: 'email', message: 'Por Favor, informe um email válido', trigger: 'blur' },
        ],
        fabricante_contato_telefone: [
          { required: true, message: "Por Favor, informe o Telefone do Contato do Fabricante", trigger: "blur" },
        ],
        fabricante_imagem: [
          { required: true, message: "Por Favor, informe a Imagem do Contato do Fabricante", trigger: "blur" },
        ],
        faturamento: [
          { required: true, message: "Por Favor, informe o Faturamento", trigger: "blur" },
        ],
        frete_tipo: [
          { required: true, message: "Por Favor, informe o Tipo de Frete", trigger: "blur" },
        ],
        frete_empresa: [
          { required: true, message: "Por Favor, informe a Empresa de Frete", trigger: "blur" },
        ],
        frete_local_cidade: [
          { required: true, message: "Por Favor, informe a Cidade do Local de Frete", trigger: "blur" },
        ],
        frete_local_uf: [ 
          { required: true, message: "Por Favor, informe a UF do Local de Frete", trigger: "blur" },
        ],
        eh_fabricante: [
          { required: true, message: "Por Favor, informe se é Fabricante", trigger: "change" },
        ],
      },
    };
  },

  mounted() {
    this.permissoes = FuncoesUteis.isPermissao();
    if (!this.permissoes.ler_configuracoes) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.buscarFabricantes();
    this.buscarConfiguracoesFabricantes();
  },

  methods: {

    async buscarFabricantes() {
      try {
        this.loading = true;
        const response = await axios.get(url + '/orcamento/negocio/pessoas/', {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.listaFabricantes = response.data;
          // Adicionar item CLIENTE FINAL no início da lista
          this.listaFabricantes.unshift({ CODIGO: "0", RAZAO_SOCIAL: "CLIENTE FINAL" });
          // console.log('listaFabricantes ', this.listaFabricantes)
        }
      } catch (error) {
        this.$message.error('Erro ao buscar Fabricantes: ' + error.message);
      } finally {
        this.loading = false;
      }
    },

    async buscarConfiguracoesFabricantes() {
      try {
        this.loading = true;
        const response = await axios.get(url + '/orcamento/negocio/configuracoes-fabricante/', {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.configuracoesFabricantes = response.data;
          // console.log(this.configuracoesFabricantes)
        }
      } catch (error) {
        this.$message.error('Erro ao buscar Configurações do Fabricante: ' + error.message);
      } finally {
        this.loading = false;
      }
    },

    formConfiguracoesFabricanteOpen(row = null) {
      if (row) {
        this.formDataConfiguracoesFabricante = { ...row };
      } else {
          this.formDataConfiguracoesFabricante = { 
            id: null,
            configuracao_id: 1,
            fabricante_id: null,
            lucro: null,
            desconto_representante: null,
            desconto_administrador: null,
            despesas_administrativas: null,
            custo_indireto: null,
            gastos_gerais_fabricacao: null,
            empresa_representante_nome: null,
            empresa_representante_email: null,
            empresa_representante_telefone: null,
            comissao_gerente: null,
            comissao_interna: null,
            comissao_externa: null,
            indicador_externo: null,
            fabricante_contato_nome: null,
            fabricante_contato_cargo: null,
            fabricante_contato_email: null,
            fabricante_contato_telefone: null,
            fabricante_rs: null,
            fabricante_imagem: null,
            faturamento: null,
            frete_tipo: null,
            frete_empresa: null,
            frete_local_cidade: null,
            frete_local_uf: null,
            eh_fabricante: null
          };
      }
      this.formConfiguracoesFabricanteVisible = true;
    },

    formConfiguracoesFabricanteClose() {
      this.$confirm("Deseja fechar sem salvar?", "Aviso", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning",
      })
        .then(() => {
          this.formConfiguracoesFabricanteVisible = false;
        })
        .catch(() => {});
    },

    submitConfiguracoesFabricante() {
      this.$refs.formConfiguracoesFabricante.validate((valid) => {
        if (!valid) {
          this.$message.info("Preencha os dados corretamente!");
          return;
        }

        const headers = { Authorization: "Bearer " + this.$store.state.token };
        const payload = { ...this.formDataConfiguracoesFabricante };
        const request = this.formDataConfiguracoesFabricante.id
          ? axios.put(`${url}/orcamento/negocio/configuracoes-fabricante/${this.formDataConfiguracoesFabricante.id}`, payload, { headers })
          : axios.post(`${url}/orcamento/negocio/configuracoes-fabricante/`, payload, { headers });

        request
          .then(() => {
            this.$notify({
              title: "Sucesso",
              message: this.formDataConfiguracoesFabricante.id ? "Registro atualizado!" : "Registro criado!",
              type: "success",
            });
            this.formConfiguracoesFabricanteVisible = false;
            this.buscarConfiguracoesFabricantes();
          })
          .catch((err) => {
            this.$notify({
              title: "Erro",
              message: "Falha ao salvar os dados. " + err,
              type: "error",
            });
          });
      });
    },

    deleteConfiguracoesFabricante(row) {
      if (row.fabricante_id == 0) {
        this.$notify({ title: "Atenção", message: "Registro CLIENTE FINAL não pode ser removido!" });
        return
      }
      this.$confirm("Deseja excluir este registro?", "Confirmação", {
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(() => {
          axios
            .delete(`${url}/orcamento/negocio/configuracoes-fabricante/${row.id}`, {
              headers: { Authorization: "Bearer " + this.$store.state.token },
            })
            .then(() => {
              this.$notify({ title: "Sucesso", message: "Registro excluído!", type: "success" });
              this.buscarConfiguracoesFabricantes();
            })
            .catch((err) => {
              this.$notify({ title: "Erro", message: "Falha ao excluir. " + err, type: "error" });
            });
        })
        .catch(() => {});
    },
  },

};

</script>

<style scoped>
  .item {
    margin:0;
  }
</style>
